import React from 'react';
import { connect } from 'react-redux';
import { has } from 'lodash';
import CountUp from 'react-countup';
import Integral from '../Intergral';
import { setDialogs } from '../../actions';
import { SignInGuideDialog } from '../../components';
import { ACCOUNT, TASK_EVOLVE_TYPE, BLACK_USER_DIALOG } from '../../const';
import { loginAction, signInAction, doPreProcess, setWelfareAnimation } from '../../rootStore';
import './index.scss';
import '../../common/css/animate-olduser.scss';
import '../../common/css/animate-loop.scss';


class SignInCoin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signIn: false,
	  signInLock: false,
    };

    this.Log = this.props.Log;
  }

  componentDidMount() {
    this.dealSiginAction();  // 自动签到、签到引导

    this.Log && this.Log.sendExposure({
      element_type: 'defaultsign',
      element_name: 'module',
    });
    this.Log && this.Log.sendExposure({
      element_type: 'total_property',
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isLogin !== this.props.isLogin) {
      this.dealSiginAction();
    }
  }


	// 签到模块展示处理，自动签到、签到引导
	dealSiginAction = () => {
	  const {
	    completed = 0,
	    hasSigned = false,
	    isContinueTask,
	    continueTaskDays = 0,
	    taskEvolve,
	  } = this.props.signTask;
	  if ([
	    TASK_EVOLVE_TYPE.WELFARE_TASK_LOCKED_BY_GUID,
	    TASK_EVOLVE_TYPE.WELFARE_TASK_LOCKED_BY_QBID,
	  ].includes(taskEvolve)) {
	    if (has(window, 'browser.app.showAlertDialog')) {
	      window.browser.app.showAlertDialog(() => {}, BLACK_USER_DIALOG);
	    }
	    return;
	  }

	  // 确认当前是第几次签到，连续任务和非连续任务取不同字段
	  const taskDays = isContinueTask ? continueTaskDays : completed;
	  const isNotMatchDeviceOrBlack = [ACCOUNT.STATUS.NOT_MATCH_DEVICE, ACCOUNT.STATUS.TINAYU_BLACK]
	  	.includes(this.props.credit);

	  if (!hasSigned && !isNotMatchDeviceOrBlack) {
	    if (taskDays == 0 && this.props.dialogs.length === 0) {  // 第一次未签到且无其他弹窗情况下出签到引导弹窗
	      this.signInGuide(taskDays);

	      this.Log && this.Log.sendExposure({
	        element_type: 'defaultsign',
	        element_name: this.props.isLogin ? 'defaultsign_popup_login' : 'defaultsign_popup_unlogin',
	      });
	    } else if (this.props.dialogs.length === 0) {  // 无其他弹窗情况下自动签到
	      signInAction('defaultsign');  // 未签到默认签到
	    }
	  } else {
		  // 没有签到弹窗就播放动画
		  setWelfareAnimation();
	  }
	}

	signInGuide = (taskDays) => {
	  const len = this.props.dialogs.length;

	  this.props.dispatch(setDialogs(this.props.dialogs.concat([
			<SignInGuideDialog key={len} Log={this.Log} from="siginCoin"></SignInGuideDialog>,
	  ])));
	}

	// 收益记录
	toIncome = (tab) => {
	  this.Log && this.Log.sendClick({
	    element_type: 'total_property',
	    element_name: `total_${tab}`,
	  });
	  this.props.history.push({ pathname: '/incomeRecord', state: {
	    tab,
	  } });
	}

	signInClick = () => {
	  const { signTask: { taskEvolve } } = this.props;
	  if ([
	    TASK_EVOLVE_TYPE.WELFARE_TASK_LOCKED_BY_GUID,
	    TASK_EVOLVE_TYPE.WELFARE_TASK_LOCKED_BY_QBID,
	  ].includes(taskEvolve)) {
	    if (has(window, 'browser.app.showAlertDialog')) {
	      window.browser.app.showAlertDialog(() => {}, BLACK_USER_DIALOG);
	    }
	    return;
	  }
	  if (this.props.isLogin) {  // 已登录
	    signInAction('defaultsign');
	  } else {  // 未登录
	    loginAction();
	  }
	}

	render() {
	  const { isShowTaotie, isShowTaotieSwing } = this.props;
	  const { integral = 0, amount = 0 } = this.props.myIntegral;
	  const { stepWelfare = [], completed = 0, hasSigned = false, actionText = '签到', isContinueTask, continueTaskDays = 0 } = this.props.signTask;

	  let curStep = 0;
	  const taskDays = isContinueTask ? continueTaskDays : completed;
	  if (hasSigned) {  // 找出今天是第几步
	    curStep = taskDays - 1;
	  } else {
	    curStep = taskDays;
	  }

	  return (
			<div className="signinCoinWrap">
				<div className="containerBg"></div>
				{/* <Integral history={this.props.history}></Integral> */}
				<div className="gka-anim-wrap">
					<div className="taotieWrap">
						<div className="animate-wrap-olduser">
							<div className={`taotie-anim-olduser ${isShowTaotie ? 'taotie-in' : ''}`}>
								<div className={`taotie-swing ${isShowTaotieSwing ? 'show' : ''}`}></div>
							</div>
						</div>
					</div>
					<div className={`gka-wrap ${isShowTaotie ? 'animation' : 'stay-coin'}`}></div>
				</div>

				<div className="signinBoard">
					<div className="title">签到领福利</div>
					{!!hasSigned
					  ? <div className="signinBtn has">已签到</div>
					  :						<div className="signinBtn" onClick={() => doPreProcess(this.signInClick)()} log-click-elname="sign" log-click-eltype="defaultsign">{actionText || '签到'}</div>
					}
					{stepWelfare.length > 0
						&& <div className="checkin">
							<div className="checkinBg"></div>
							<div className="info">
								<div className="line"></div>
								{stepWelfare.map((step, index) => {
								  let type = '';
								  const welfareInfo = step.welfareInfo || {};
								  if (welfareInfo.welfareType === 0 || welfareInfo.welfareType === 4) {  // 现金奖励
								    type = 'cash';
								  }

								  return (
										<div className={`item ${index === curStep ? 'active' : ''}`} key={index}>
											{!!step.stepDesc && index > (taskDays - 1)
												&& <div className="bubbleBox">
													<div className="bubble">{step.stepDesc}</div>
													<div className="triggle"></div>
												</div>
											}
											<div className="iconWrap">
												<div className={`icon ${type === 'cash' ? 'redPack' : 'yellowPack'} `}>
													{index <= (taskDays - 1)
														&& <div className="signed"></div>
													}
												</div>
											</div>
											<div className="day">
												{index === curStep ? '今天' : `${index + 1}天`}
											</div>
										</div>
								  );
								})}
							</div>
						</div>
					}

				</div>

			</div>
	  );
	}
}

const mapStateToProps = (state) => {
  const { dialogs, myIntegral, signTask, kbApp, isLogin, preProcess, credit, isShowTaotie, isShowTaotieSwing } = state;
  return {
    dialogs,
    myIntegral,
    signTask,
    kbApp,
    isLogin,
    preProcess,
    credit,
    isShowTaotie,
    isShowTaotieSwing,
  };
};

export default connect(mapStateToProps)(SignInCoin);
